import {
  MobileFooterInnerWraper,
  MobileFooterLink,
  MobileFooterNav,
} from '@auth/pages/Auth.styles';
import { useConfig } from '@hooks/useConfig';
import { useGetLinks } from '@hooks/useGetLinks';
import { useI18n } from '@hooks/useI18n/useI18n';
import { Copyright } from './Copyright';

export const MobileFooter = () => {
  const { showFooter } = useConfig();
  const { translate } = useI18n();
  const { privacyPolicy } = useGetLinks();

  return (
    <>
      {showFooter ? (
        <MobileFooterInnerWraper>
          <Copyright
            companyLegalName={translate('GENERAL.COMPANY_LEGAL_NAME')}
          />
          <MobileFooterNav>
            <MobileFooterLink href={privacyPolicy}>
              {translate('LINK.PRIVACY')}
            </MobileFooterLink>
          </MobileFooterNav>
        </MobileFooterInnerWraper>
      ) : null}
    </>
  );
};
